import {
  GET_ALL_EQUIPMENT,
  GET_ALL_EQUIPMENT_SUCCESS,
  GET_ALL_EQUIPMENT_ERROR,
  CREATE_EQUIPMENT,
  CREATE_EQUIPMENT_SUCCESS,
  CREATE_EQUIPMENT_ERROR,
  GET_EQUIPMENT_TYPES,
  GET_EQUIPMENT_TYPES_SUCCESS,
  GET_EQUIPMENT_TYPES_ERROR,
  GET_EQUIPMENT_BRANDS,
  GET_EQUIPMENT_BRANDS_SUCCESS,
  GET_EQUIPMENT_BRANDS_ERROR,
} from './constants';

export function getAllEquipment() {
  return {
    type: GET_ALL_EQUIPMENT,
  };
}

export function getAllEquipmentSuccess(payload) {
  return {
    type: GET_ALL_EQUIPMENT_SUCCESS,
    payload,
  };
}

export function getAllEquipmentError(err) {
  return {
    type: GET_ALL_EQUIPMENT_ERROR,
    err,
  };
}

export function createEquipment() {
  return {
    type: CREATE_EQUIPMENT,
  };
}

export function createEquipmentSuccess(payload) {
  return {
    type: CREATE_EQUIPMENT_SUCCESS,
    payload,
  };
}

export function createEquipmentError(err) {
  return {
    type: CREATE_EQUIPMENT_ERROR,
    err,
  };
}

export function getEquipmentTypes() {
  return {
    type: GET_EQUIPMENT_TYPES,
  };
}

export function getEquipmentTypesSuccess(payload) {
  return {
    type: GET_EQUIPMENT_TYPES_SUCCESS,
    payload,
  };
}

export function getEquipmentTypesError(err) {
  return {
    type: GET_EQUIPMENT_TYPES_ERROR,
    err,
  };
}

export function getEquipmentBrands() {
  return {
    type: GET_EQUIPMENT_BRANDS,
  };
}

export function getEquipmentBrandsSuccess(payload) {
  return {
    type: GET_EQUIPMENT_BRANDS_SUCCESS,
    payload,
  };
}

export function getEquipmentBrandsError(err) {
  return {
    type: GET_EQUIPMENT_BRANDS_ERROR,
    err,
  };
}
